import React, { useState } from "react";
import { api } from "../../lib/api";
import { act } from "../../lib/useFetch";
import { toInputValue, fromInputValue } from "../../lib/format";
import AdminDialog, { Field, DialogButtons } from "./AdminDialog";

export default function EventDialog({ event, onClose, onSaved }) {
  const [form, setForm] = useState({ title: event.title || "", start: toInputValue(event.start), end: toInputValue(event.end), notes: event.notes || "" });
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const save = async (e) => {
    e.preventDefault();
    const payload = { title: form.title, start: fromInputValue(form.start), end: fromInputValue(form.end), notes: form.notes };
    const res = event.id
      ? await act(api.put(`/admin/calendar/${event.id}`, payload), "Событие сохранено")
      : await act(api.post("/admin/calendar", payload), "Событие добавлено");
    if (res) onSaved();
  };
  const remove = async () => {
    if (!window.confirm("Удалить событие?")) return;
    if (await act(api.delete(`/admin/calendar/${event.id}`), "Событие удалено")) onSaved();
  };

  return (
    <AdminDialog title={event.id ? "✏️ Событие" : "➕ Личное событие"} onClose={onClose} testid="event-dialog">
      <form onSubmit={save} className="space-y-3">
        <Field label="Название"><input required value={form.title} onChange={set("title")} data-testid="event-title-input" /></Field>
        <div className="grid grid-cols-2 gap-3">
          <Field label="Начало"><input required type="datetime-local" value={form.start} onChange={set("start")} data-testid="event-start-input" /></Field>
          <Field label="Окончание"><input type="datetime-local" value={form.end} onChange={set("end")} data-testid="event-end-input" /></Field>
        </div>
        <Field label="Заметки"><textarea rows={3} value={form.notes} onChange={set("notes")} data-testid="event-notes-input" /></Field>
        {event.id && <button type="button" onClick={remove} className="text-xs text-red-400 underline" data-testid="event-delete-btn">Удалить событие</button>}
        <DialogButtons onClose={onClose} testid="event" />
      </form>
    </AdminDialog>
  );
}
